(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fat-buddha-portfolio-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();

    const setup = (root) => {
      if (initialized.has(root)) return;
      initialized.add(root);

      const track = root.querySelector('[data-fb-track]');
      const slides = Array.from(root.querySelectorAll('[data-fb-slide]'));
      const previous = root.querySelector('[data-fb-prev]');
      const next = root.querySelector('[data-fb-next]');
      const current = root.querySelector('[data-fb-current]');
      const progress = root.querySelector('[data-fb-progress]');
      if (!track || slides.length < 2) return;

      let active = 0;
      let timer;
      let frame;

      const setActive = (index) => {
        active = (index + slides.length) % slides.length;
        if (current) current.textContent = String(active + 1).padStart(2, '0');
        if (progress) progress.style.transform = `scaleX(${(active + 1) / slides.length})`;
      };

      const goTo = (index) => {
        const target = (index + slides.length) % slides.length;
        track.scrollTo({ left: slides[target].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        setActive(target);
      };

      const restart = () => {
        window.clearInterval(timer);
        if (root.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = window.setInterval(() => goTo(active + 1), Number(root.dataset.delay) || 5000);
      };

      previous?.addEventListener('click', () => { goTo(active - 1); restart(); });
      next?.addEventListener('click', () => { goTo(active + 1); restart(); });

      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(active - 1); restart(); }
        if (event.key === 'ArrowRight') { event.preventDefault(); goTo(active + 1); restart(); }
      });

      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(() => {
          const left = track.scrollLeft;
          const closest = slides.reduce((best, slide, index) => {
            const distance = Math.abs(slide.offsetLeft - track.offsetLeft - left);
            return distance < best.distance ? { index, distance } : best;
          }, { index: 0, distance: Infinity });
          setActive(closest.index);
        });
      }, { passive: true });

      root.addEventListener('mouseenter', () => window.clearInterval(timer));
      root.addEventListener('mouseleave', restart);
      root.addEventListener('focusin', () => window.clearInterval(timer));
      root.addEventListener('focusout', restart);
      document.addEventListener('visibilitychange', () => document.hidden ? window.clearInterval(timer) : restart());

      setActive(0);
      restart();
    };

    const initialize = (scope = document) => scope.querySelectorAll('[data-fb-portfolio]').forEach(setup);
    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fb-service-packages"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fb-service-enquiry')) {
  customElements.define('fb-service-enquiry', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.form = this.dialog.querySelector('form');
      this.select = this.querySelector('[data-enquiry-service]');
      if (!this.dialog.showModal) return;
      this.key = 'fb-enquiry-' + this.form.id;
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-enquiry-trigger]');
        if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.trigger = trigger;
        if (this.select) {
          const choice = [...this.select.options].find(o => o.dataset.block === trigger.dataset.enquiryTrigger);
          if (choice) this.select.value = choice.value;
          this.updateFields();
        }
        this.open();
      }, options);
      this.querySelectorAll('[data-enquiry-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
      this.dialog.addEventListener('click', event => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => { this.restoreScroll(); this.trigger?.focus(); }, options);
      this.select?.addEventListener('change', () => this.updateFields(), options);
      this.form.addEventListener('submit', () => {
        try { sessionStorage.setItem(this.key, this.select?.selectedOptions[0]?.dataset.block || ''); } catch {}
      }, options);
      let pending;
      try { pending = sessionStorage.getItem(this.key); } catch {}
      const status = this.querySelector('[data-enquiry-status]');
      if (status && (pending !== null && pending !== undefined || location.hash === '#' + this.form.id)) {
        if (this.select && pending) {
          const choice = [...this.select.options].find(o => o.dataset.block === pending);
          if (choice) this.select.value = choice.value;
        }
        this.updateFields();
        this.open();
        status.focus();
        try { sessionStorage.removeItem(this.key); } catch {}
      }
    }
    updateFields() {
      if (!this.select) return;
      const type = this.select.selectedOptions[0]?.dataset.serviceType || 'new';
      this.querySelectorAll('[data-existing-store], [data-migration-only]').forEach(group => {
        const visible = group.hasAttribute('data-migration-only') ? type === 'migration' : type !== 'new';
        group.hidden = !visible;
        group.querySelectorAll('input').forEach(input => { input.disabled = !visible; });
      });
      this.querySelectorAll('[data-enquiry-hint], [data-message-label]').forEach(el => { el.textContent = el.dataset[type]; });
    }
    open() {
      if (this.dialog.open) return;
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
    }
    restoreScroll() {
      if (this.previousOverflow !== undefined) {
        document.documentElement.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
    }
    disconnectedCallback() {
      this.restoreScroll();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header');
			this.headerWrapper = document.querySelector('.header-wrapper');
			this.headerIsAlwaysSticky =
				this.getAttribute('data-sticky-type') === 'always';
			this.currentScrollTop = 0;
			this.preventReveal = false;
			this.predictiveSearch = this.querySelector('predictive-search');

			this.headerCoords = {};
			this.calcHeaderCoords();

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);
		}

		disconnectedCallback() {
			this.removeEventListener(
				'preventHeaderReveal',
				this.hideHeaderOnScrollUp,
			);
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		calcHeaderCoords() {
			const clientRect = this.getBoundingClientRect();
			const pageYOffset =
				window.pageYOffset || document.documentElement.scrollTop;
			this.headerCoords.bottom = pageYOffset + clientRect.bottom;
			this.headerCoords.top = pageYOffset + clientRect.top;
		}

		onScroll() {
			const scrollTop =
				window.pageYOffset || document.documentElement.scrollTop;

			if (this.headerIsAlwaysSticky) {
				if (this.header.classList.contains('color-background-overlay')) {
					if (scrollTop > this.header.offsetHeight + 1) {
						this.header.classList.remove('color-background-overlay');
						this.header.classList.add(
							'color-background-overlay-hidden',
							'shopify-section-header-sticky',
						);
					}
				}

				if (this.header.classList.contains('color-background-overlay-hidden')) {
					if (scrollTop < this.header.offsetHeight) {
						this.header.classList.add('color-background-overlay');
						this.header.classList.remove(
							'color-background-overlay-hidden',
							'shopify-section-header-sticky',
						);
					}
				}
			}

			if (
				scrollTop > this.currentScrollTop &&
				scrollTop > this.headerCoords.bottom
			) {
				if (this.preventHide) return;
				requestAnimationFrame(this.hide.bind(this));
			} else if (
				scrollTop < this.currentScrollTop &&
				scrollTop > this.headerCoords.bottom
			) {
				if (!this.preventReveal) {
					requestAnimationFrame(this.reveal.bind(this));
				} else {
					window.clearTimeout(this.isScrolling);

					this.isScrolling = setTimeout(() => {
						this.preventReveal = false;
					}, 66);

					requestAnimationFrame(this.hide.bind(this));
				}
			} else if (scrollTop <= this.headerCoords.top) {
				requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add(
				'shopify-section-header-hidden',
				'shopify-section-header-sticky',
			);
			this.closeMenuDisclosure();
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');

			if (this.header.classList.contains('color-background-overlay')) {
				this.header.classList.remove('color-background-overlay');
				this.header.classList.add('color-background-overlay-hidden');
			}
		}

		reset() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.remove(
				'shopify-section-header-hidden',
				'shopify-section-header-sticky',
				'animate',
			);

			if (this.header.classList.contains('color-background-overlay-hidden')) {
				this.header.classList.add('color-background-overlay');
				this.header.classList.remove('color-background-overlay-hidden');
			}
		}

		closeMenuDisclosure() {
			this.disclosures =
				this.disclosures || this.header.querySelectorAll('details-disclosure');
			if (typeof DetailsDisclosure !== 'undefined') {
				this.disclosures.forEach(disclosure => {
					disclosure.close();
				});
			}
			this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			this.disclosureLists.forEach(disclosureList => {
				disclosureList.setAttribute('hidden', true);
			});
		}
	}

	customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();
			this.spinnerIcon = this.querySelector('.cart__note-loading');
			this.successIcon = this.querySelector('.cart__note-success');
			this.textarea = this.querySelector('textarea');
			this.cartButtons = document.querySelector('.cart__ctas');

			this.textarea.addEventListener(
				'input',
				debounce((event) => {
					this.spinnerIcon.style.display = 'block';
					this.successIcon.style.display = 'none';
					this.cartButtons.style.pointerEvents = 'none';
					this.cartButtons.style.opacity = '0.7';

					const body = JSON.stringify({ note: event.target.value });

					fetch(`${routes.cart_update_url}`, {
						...fetchConfig(),
						...{ body },
					})
						.then((response) => {
							if (!response.ok) {
								throw new Error('Network response was not ok');
							}
							return response.json();
						})
						.then((data) => {
							this.successIcon.style.display = 'block';

							setTimeout(() => {
								this.successIcon.style.display = 'none';
							}, 2000);
						})
						.catch((error) => {
							console.error(
								'There was a problem with the fetch operation:',
								error,
							);
						})
						.finally(() => {
							this.spinnerIcon.style.display = 'none';
							this.cartButtons.removeAttribute('style');
						});
				}, 300),
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-enquiry-steps"] && !Shopify.designMode) return;
  try {
    
  (() => {
  const initProjectEnquirySteps = (scope = document) => {
    const forms = [
      ...(scope.matches?.('.project-enquiry__form--steps') ? [scope] : []),
      ...scope.querySelectorAll('.project-enquiry__form--steps')
    ];

    forms.forEach((form) => {
    if (form.dataset.multistepInitialised === 'true') return;

    const steps = [...form.querySelectorAll('[data-project-step]')];
    const progressItems = [...form.querySelectorAll('.project-enquiry__progress-list li')];
    const progressBar = form.querySelector('[data-project-progress-bar]');
    const stepStatus = form.querySelector('[data-project-step-status]');
    const stepTitle = form.querySelector('[data-project-step-title]');
    const titles = ['Your details', 'Your project', 'Project brief'];
    let currentStep = 0;

    if (!steps.length) return;

    form.dataset.multistepInitialised = 'true';
    form.classList.add('is-multistep-ready');
    form.noValidate = true;

    const showError = (field) => {
      if (!field.id) return;

      const errorId = `${field.id}-validation-error`;
      let error = form.querySelector(`#${CSS.escape(errorId)}`);

      if (!error) {
        error = document.createElement('small');
        error.id = errorId;
        error.className = 'project-enquiry__field-error';
        error.setAttribute('role', 'alert');

        field
          .closest('.project-enquiry__field, .project-enquiry__consent')
          ?.append(error);
      }

      if (error) error.textContent = field.validationMessage;
      field.setAttribute('aria-invalid', 'true');

      const descriptions = new Set(
        (field.getAttribute('aria-describedby') || '')
          .split(' ')
          .filter(Boolean)
      );

      descriptions.add(errorId);
      field.setAttribute('aria-describedby', [...descriptions].join(' '));
    };

    const clearError = (field) => {
      if (!field.validity.valid || !field.id) return;

      const errorId = `${field.id}-validation-error`;
      form.querySelector(`#${CSS.escape(errorId)}`)?.remove();
      field.removeAttribute('aria-invalid');

      const descriptions = (field.getAttribute('aria-describedby') || '')
        .split(' ')
        .filter((id) => id && id !== errorId);

      if (descriptions.length) {
        field.setAttribute('aria-describedby', descriptions.join(' '));
      } else {
        field.removeAttribute('aria-describedby');
      }
    };

    const showStep = (index, moveFocus = true) => {
      currentStep = Math.max(0, Math.min(index, steps.length - 1));

      steps.forEach((step, stepIndex) => {
        step.hidden = stepIndex !== currentStep;
      });

      progressItems.forEach((item, itemIndex) => {
        item.classList.toggle('is-complete', itemIndex < currentStep);
        if (itemIndex === currentStep) {
          item.setAttribute('aria-current', 'step');
        } else {
          item.removeAttribute('aria-current');
        }
      });

      if (progressBar) {
        progressBar.style.width = `${((currentStep + 1) / steps.length) * 100}%`;
      }

      if (stepStatus) stepStatus.textContent = `Step ${currentStep + 1} of ${steps.length}`;
      if (stepTitle) stepTitle.textContent = titles[currentStep];

      if (moveFocus) {
        const legend = steps[currentStep].querySelector('legend');
        if (legend) {
          legend.tabIndex = -1;
          legend.focus({ preventScroll: true });
        }
        form.closest('.project-enquiry__form-wrap')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    const invalidFieldsIn = (container) =>
      [...container.querySelectorAll('input, select, textarea')]
        .filter((field) => !field.disabled && !field.validity.valid);

    const validateStep = (step) => {
      const invalidFields = invalidFieldsIn(step);
      invalidFields.forEach(showError);

      if (invalidFields.length) {
        invalidFields[0].focus();
        invalidFields[0].reportValidity();
        return false;
      }

      return true;
    };

    form.addEventListener('click', (event) => {
      const next = event.target.closest('[data-project-next]');
      const back = event.target.closest('[data-project-back]');

      if (next && validateStep(steps[currentStep])) {
        showStep(currentStep + 1);
      }

      if (back) showStep(currentStep - 1);
    });

    form.addEventListener('submit', (event) => {
      const invalidField = [...form.querySelectorAll('input, select, textarea')]
        .find((field) => !field.disabled && !field.validity.valid);

      if (!invalidField) return;

      event.preventDefault();
      const invalidStep = steps.findIndex((step) => step.contains(invalidField));
      if (invalidStep !== -1) showStep(invalidStep, false);
      invalidFieldsIn(steps[invalidStep]).forEach(showError);
      invalidField.focus();
      invalidField.reportValidity();
    });

    form.addEventListener('input', (event) => clearError(event.target));
    form.addEventListener('change', (event) => clearError(event.target));

    showStep(0, false);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProjectEnquirySteps());
  } else {
    initProjectEnquirySteps();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initProjectEnquirySteps(event.target);
  });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-enquiry"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.project-enquiry__form').forEach((form) => {
    const showError = (field) => {
      const errorId = `${field.id}-validation-error`;
      let error = form.querySelector(`#${errorId}`);

      if (!error) {
        error = document.createElement('small');
        error.id = errorId;
        error.className = 'project-enquiry__field-error';
        error.setAttribute('role', 'alert');

        field
          .closest('.project-enquiry__field, .project-enquiry__consent')
          .append(error);
      }

      error.textContent = field.validationMessage;
      field.setAttribute('aria-invalid', 'true');

      const descriptions = new Set(
        (field.getAttribute('aria-describedby') || '')
          .split(' ')
          .filter(Boolean)
      );

      descriptions.add(errorId);
      field.setAttribute('aria-describedby', [...descriptions].join(' '));
    };

    const clearError = (field) => {
      if (!field.validity.valid) return;

      const errorId = `${field.id}-validation-error`;
      form.querySelector(`#${errorId}`)?.remove();
      field.removeAttribute('aria-invalid');

      const descriptions = (field.getAttribute('aria-describedby') || '')
        .split(' ')
        .filter((id) => id && id !== errorId);

      if (descriptions.length) {
        field.setAttribute('aria-describedby', descriptions.join(' '));
      } else {
        field.removeAttribute('aria-describedby');
      }
    };

    form.addEventListener(
      'invalid',
      (event) => showError(event.target),
      true
    );

    form.addEventListener('input', (event) => clearError(event.target));
    form.addEventListener('change', (event) => clearError(event.target));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('testimonials-slider')) return;

    class TestimonialsSlider extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.index = 0;
        this.track = this.querySelector('[data-slider-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slider-slide]'));
        this.previousButton = this.querySelector('[data-slider-previous]');
        this.nextButton = this.querySelector('[data-slider-next]');
        this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'));

        this.revealHeading();
        if (!this.track || this.slides.length < 1) return;

        this.previousButton?.addEventListener('click', () => this.goTo(this.index - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1));
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.sliderDot)));
        });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.goTo(this.index - 1);
          if (event.key === 'ArrowRight') this.goTo(this.index + 1);
        });

        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this);
        this.update();

        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            const slide = event.target.closest('[data-slider-slide]');
            if (slide) this.goTo(Number(slide.dataset.slideIndex));
          });
        }
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.headingObserver?.disconnect();
      }

      revealHeading() {
        const heading = this.querySelector('[data-slider-heading]');
        if (!heading) return;

        if (!('IntersectionObserver' in window)) {
          heading.classList.add('is-visible');
          return;
        }

        this.headingObserver = new IntersectionObserver(([entry]) => {
          if (!entry.isIntersecting) return;
          heading.classList.add('is-visible');
          this.headingObserver.disconnect();
        }, { threshold: 0.1 });
        this.headingObserver.observe(heading);
      }

      goTo(nextIndex) {
        this.index = Math.max(0, Math.min(nextIndex, this.slides.length - 1));
        this.update();
      }

      update() {
        const firstSlide = this.slides[0];
        if (!firstSlide || !this.track) return;
        const gap = Number.parseFloat(getComputedStyle(this.track).gap) || 8;
        const step = firstSlide.getBoundingClientRect().width + gap;
        this.track.style.transform = `translate3d(-${this.index * step}px, 0, 0)`;
        if (this.previousButton) this.previousButton.disabled = this.index === 0;
        if (this.nextButton) this.nextButton.disabled = this.index === this.slides.length - 1;
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });
      }
    }

    customElements.define('testimonials-slider', TestimonialsSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-ratings-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    const initialize = (root = document) => {
      if (!window.Trustpilot) return;
      root.querySelectorAll('.trust-ratings .trustpilot-widget').forEach((widget) => {
        if (!widget.querySelector('iframe')) window.Trustpilot.loadFromElement(widget, true);
      });
    };
    const load = () => {
      if (window.Trustpilot) {
        initialize();
        return;
      }
      let script = Array.from(document.scripts).find((item) => item.src === src);
      if (!script) {
        script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.addEventListener('load', () => initialize(), { once: true });
        document.head.appendChild(script);
      } else {
        script.addEventListener('load', () => initialize(), { once: true });
      }
    };
    load();
    document.addEventListener('shopify:section:load', load);
  })();

  } catch(e) { console.error(e); }
})();
})();
